export default function MonoText_Frameless({ item, isSub }) {
  const hitRange = item.scale.ranges.find(
    (range) => range.start <= Number(item.score) && Number(item.score) <= range.end
  );

  return item.scale?.isHtml ? (
    <div className={"mx-0 " + (!hitRange && "d-none")} dangerouslySetInnerHTML={{ __html: hitRange?.text }} />
  ) : (
    <div
      style={{
        fontSize: "16px",
        fontFamily: "montserat, sans-serif",
        textAlign: "left",
        position: "relative",
        paddingLeft: "15px",
      }}
    >
      <span
        style={{
          position: "absolute",
          left: "0",
          color: "black",
          fontWeight: "bold",
        }}
      >
        •
      </span>
      {hitRange?.text}
    </div>
  );
}
